import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Button from 'components/Button/Button';
import qs from 'qs';
import React from 'react';

const Container = styled('div')`
  background-color: ${({ theme }) => theme.palette.primary.main};
  height: 100vh;
  color: #fff;
  text-align: center;
  overflow: hidden;
  .logo {
    width: 200px;
    margin: 3rem auto;
  }
`;

export default ({ actionLink, actionLinkLabel, location }) => {
  const query = qs.parse(location.search.substr(1));
  return (
    <Container>
      <div className="logo">
        <img src="/assets/svg/logo.svg" />
      </div>
      <Typography variant="h1" color="inherit" sx={{ mb: 3 }}>
        Oops!
      </Typography>
      <Typography color="inherit" variant="h4" sx={{ mb: 4 }}>
        {query.message}
      </Typography>
      {actionLink ? (
        <a href={actionLink}>
          <Button>{actionLinkLabel}</Button>
        </a>
      ) : (
        <a href="/">
          <Button color="primary">Go Back</Button>
        </a>
      )}
    </Container>
  );
};
